import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";
import { useSelector,useDispatch } from "react-redux";
import { useEffect } from "react";
import axios from "axios";
import { set_user } from "redux/reducer/user";
import Navbar from '../component/Navbar';
import Footer from "../component/Footer";

export const PageLayout = () => {
    const loaded = useSelector(state => state.user.loaded);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const {pathname}=useLocation();
    const isAuthPage = /^\/(login|register|verify)/.test(pathname);

    useEffect(()=>{
        window.scrollTo(0,0)
    },[pathname])

    return (
        <Box sx={{ padding: 0, margin: 0, minHeight: { xs: '100dvh', sm: '100vh' }, display: 'flex', flexDirection: 'column', bgcolor: '#21232E' }}>
            <Navbar />
            <Box sx={{ padding: 0, flex: 1, display: 'flex', flexDirection: 'column', bgcolor: '#21232E' }}>
                {/* {
                    !loaded ? <Box sx={{ width: '100vw', height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <CircularProgress sx={{color:"common.white"}} />
                    </Box> : <Outlet />
                } */}
                <Outlet />
            </Box>
            {!isAuthPage && <Footer />}
        </Box>
    )
}

export default PageLayout;